import { createReservation } from '../services/api';
import { parseCartItems } from '../utilities/cartUtility';

export const submitReservation = (data) => () => {
  const items = parseCartItems(data.items);
  const { retry, checkExpires } = data;

  return createReservation(items, true, retry, checkExpires);
};

export default {
  submitReservation,
};
